// Copy literal do módulo Central de IA — contrato spec-002 §2.3 (ui-components.md).
// Nenhuma dessas strings deve ser reescrita inline em componente/view/modal: sempre
// importar daqui (regra CLAUDE.md — zero magic string de copy espalhada).

export const ACEITE_GUARDRAILS_LABEL =
  'Entendo que as saídas são material de apoio e a decisão final é do profissional.'

export const INSTRUCOES_ADICIONAIS_HELPER =
  'Adicionadas ao comportamento padrão — não substituem as regras de segurança.'

export const API_CHANNEL_TOOLTIP = 'Disponível via chave de API'

// Nome do módulo no `page.title` das views (`creditos.vue`, `creditos-pagamento.vue`).
export const MODULE_PAGE_NAME = 'Central de IA'

// Card do catálogo (`agent-card`): status da instância em palavra + aria do botão que abre
// a configuração. Cor em `constants/colors.js`.
export const AGENT_CARD = {
  STATUS_ATIVO: 'Ativo',
  STATUS_PAUSADO: 'Pausado',
  ARIA_ABRIR_CONFIGURACAO: (status) => `${status}, abrir configuração do agente`,
}

export const WORKFLOW_CHANNEL_LABEL = 'Automações (workflow)'

// Espelha o fallback do backend (run_gates): instância sem a chave `workflow`
// herda o valor de `api` até o gestor tocar o switch — daí o texto.
export const WORKFLOW_CHANNEL_TOOLTIP =
  'Permite usar este agente como etapa de automações do escritório. Enquanto não configurado, acompanha o canal API externa.'

// Rótulos de canal por valor do backend — única fonte (substitui ternários binários).
// Canais do framework (chat/api/workflow) + os canais SINTÉTICOS das superfícies que
// consomem IA fora do catálogo de agentes e vivem em `aawz_ai_usage` (copiloto da Home,
// comitê, documentos, transcrições). Vêm do backend em `core/consumo_ia.py`; ficam
// separados de propósito — chamar o copiloto de "Chat" faria o filtro devolver dois
// tipos diferentes de execução sob o mesmo rótulo.
export const CANAL_LABELS = {
  chat: 'Chat',
  api: 'API',
  workflow: 'Automações',
  copiloto: 'Copiloto',
  automacao: 'Automação',
}

export const WRITE_TOGGLE_LABEL = 'Permitir ações de escrita'

export const WRITE_TOGGLE_HELPER =
  'Criar tarefas, oportunidades e registros no CRM.'

// Tooltip do toggle de escrita quando desabilitado por falta da flag NC-5
// (`FEATURES.AI_FRAMEWORK_WRITE_TOOLS`) no escritório — reusado no wizard (G12)
// e no modal Configurar (G13).
export const WRITE_TOGGLE_DISABLED_TOOLTIP =
  'Disponível apenas para escritórios com a funcionalidade de ações de escrita habilitada.'

// Interpolar com o nome do escritório da sessão: CONFIRMACAO_TITULO.replace('{escritorio}', nome)
export const CONFIRMACAO_TITULO = 'Agente ativado para {escritorio}'

// Único CTA da confirmação — "Conversar agora" fica OCULTO até spec-003 (RF8.4).
export const CONFIRMACAO_CTA = 'Ver Meus Agentes'

// Interpolar com o número da versão: VERSAO_CHIP_LABEL.replace('{n}', versao)
export const VERSAO_CHIP_LABEL = 'v{n} disponível — atualizar'

// NC-6 — espelho da constante backend; limite do textarea "Instruções adicionais".
export const PROMPT_ADICIONAL_MAX = 4000

export const WIZARD_STEPS = ['Revisar', 'Personalizar', 'Permissões e canais']

export const TODOS_PROFISSIONAIS_LABEL = 'Todos os profissionais'

export const INDISPONIVEL_LABEL = 'Indisponível no catálogo'

// spec-003 (Conversar) — contrato ui-components §2.2 (copy literal, G8).
// Interpoladores recebem o nome da instância do agente (não o nome do template).
// ★ Copy PROIBIDA no contexto de proposta: qualquer variação de "criada/agendada/feita"
// (wireframes §2.4). Mensagens de GATE (403/404/409/429) NÃO ficam aqui — a UI renderiza
// o `r.message` EXATO do backend (as strings foram desenhadas para não vazar o eixo — RF4.1e).
export const CHAT = {
  EMPTY_TITLE: (nome) => `Converse com o ${nome}`,
  EMPTY_SUBTITLE:
    'Pergunte sobre seus clientes e prepare reuniões. As respostas usam apenas os dados que você já pode acessar na plataforma.',
  DISCLAIMER: 'As respostas são material de apoio. A decisão final é do profissional.',
  PLACEHOLDER: (nome) => `Pergunte ao ${nome}...`,
  EMPTY_AGENTS_TITLE: 'Nenhum agente disponível para conversar',
  EMPTY_AGENTS_SUBTITLE:
    'Ative um agente no catálogo ou fale com o gestor do seu escritório para liberar o acesso.',
  EMPTY_AGENTS_CTA: 'Explorar catálogo',
  STREAM_ERROR: 'Não foi possível concluir a resposta. Tente novamente.',
  PROPOSAL_STATUS: 'Aguardando aprovação de um gestor',
  PROPOSAL_SUBCOPY: 'Nada foi criado ainda. Um gestor do escritório decidirá esta ação.',
  NOVA_CONVERSA: 'Nova conversa',
}

// Título do `proposed-action-card` (G3). Os campos `operacao`/`entidade` chegam já em
// PT-BR do backend (api.yaml: `operacao: criar`, `entidade: tarefa`) — os mapas apenas
// capitalizam/humanizam com fallback seguro (nunca ecoa nome interno de tool — NC-3).
export const OPERACAO_LABELS = {
  criar: 'Criar',
  editar: 'Editar',
  create: 'Criar',
  edit: 'Editar',
  update: 'Editar',
}

export const ENTIDADE_LABELS = {
  tarefa: 'tarefa',
  oportunidade: 'oportunidade',
  ativo: 'ativo',
  movimentacao: 'movimentação',
  atividade_crm: 'atividade do CRM',
  cliente_dados: 'dados do cliente',
}

// spec-004 (Auditoria & Aprovações) — contrato ui-components §2.2 (copy literal, G15).
// ★ Copy PROIBIDA em proposta pendente / desfecho: qualquer variação de
// "criada/agendada/feita" quando `commit_status !== 'executado'` (journey F3 — a UI nunca
// finge execução). Mensagens de GATE (403/404/409/422) NÃO ficam aqui: a UI renderiza o
// TEXTO EXATO de `r.message` do backend (desenhadas para não vazar o eixo/isolamento).
export const APPROVALS = {
  TITLE: 'Aprovações pendentes',
  SUBTITLE: 'Ações de escrita propostas por agentes que aguardam sua decisão.',
  FILTER_AGENTE: 'Agente',
  FILTER_PROFISSIONAL: 'Profissional',
  FILTER_PERIODO: 'Período',
  EXPAND_SHOW: 'Ver detalhes da ação',
  EXPAND_HIDE: 'Ocultar detalhes da ação',
  BTN_APROVAR: 'Aprovar',
  BTN_RECUSAR: 'Recusar',
  // Modal Aprovar (confirmação leve — $showModal)
  APPROVE_TITLE: 'Aprovar esta ação?',
  APPROVE_BODY: (autor) =>
    `A ação será executada agora, com a carteira de ${autor} (autor). Você é o responsável pela decisão.`,
  APPROVE_JUSTIFICATIVA_LABEL: 'Justificativa (opcional)',
  // Modal Recusar (GlobalBus — justificativa obrigatória)
  REJECT_TITLE: 'Recusar esta ação',
  REJECT_JUSTIFICATIVA_LABEL: 'Justificativa',
  // Snacks de desfecho (dirigidos por commit_status — NUNCA "criada" quando não foi)
  SNACK_EXECUTADO: 'Ação executada.',
  SNACK_ESCOPO_INVALIDO:
    'Aprovado, porém não executado: o responsável não tem mais acesso a este cliente.',
  SNACK_GATE_REVOGADO:
    'Aprovado, porém não executado: as ações de escrita foram desabilitadas neste agente.',
  SNACK_ERRO_COMMIT: 'Aprovado, porém não executado.',
  SNACK_RECUSADO: 'Ação recusada.',
  SNACK_JA_DECIDIDA: 'Esta ação já foi decidida.',
  SNACK_FALHA_ATOMICIDADE: 'Não foi possível executar a ação. Tente novamente.',
  // Empty state (fila vazia — estado saudável)
  EMPTY_TITLE: 'Nenhuma aprovação pendente',
  EMPTY_SUBTITLE:
    'Quando um agente propuser uma ação de escrita, ela aparece aqui para sua decisão.',
  EMPTY_CTA: 'Ir para Conversar',
}

// Rótulos humanos de commit_status (na timeline/card de decisão — nunca o slug cru).
export const COMMIT_STATUS_LABELS = {
  executado: 'Executado',
  escopo_invalido: 'Não executado — sem acesso ao cliente',
  gate_revogado: 'Não executado — escrita desabilitada no agente',
  erro: 'Não executado',
}

export const DECISION_LABELS = { aprovado: 'Aprovado', rejeitado: 'Recusado' }

// ★ Marcador de débito abaixo de um centésimo de crédito. Vive FORA dos dois blocos que
// o usam — a coluna Créditos do log (`EXECUTIONS`) e a lista de movimentações
// (`CREDITOS_EXTRATO`) — porque é UMA regra de exibição: em duas cópias, uma muda sozinha
// e a tela passa a contar duas histórias sobre o mesmo débito. (Foi assim que a lista
// nasceu exibindo `0,00` enquanto a coluna já exibia `< 0,01` — achado na renderização.)
export const CREDITOS_SUBCENTAVO = '< 0,01'

// ★ Marcador de crédito AUSENTE, pela mesma razão e no mesmo lugar do `CREDITOS_SUBCENTAVO`:
// é UMA regra de exibição lida por dois blocos. ADR-011/US-1 — run sem lançamento no ledger
// (e lançamento sem valor numérico) não é grátis, é NÃO DEBITADO. `0,00` na célula se lê
// como "grátis" e materializa o risco nº 1 do projeto ("saldo que mente por omissão").
// Nunca troque esta copy por um zero.
export const CREDITOS_NAO_DEBITADO = 'não debitado'

export const EXECUTIONS = {
  TITLE: 'Execuções',
  // "de IA", e não "dos agentes": a tabela passou a listar TODO o consumo de IA do
  // escritório — agentes do catálogo e também copiloto, documentos e comitê, que
  // vivem em `aawz_ai_usage` e antes não apareciam em lugar nenhum.
  SUBTITLE_GESTOR: 'Auditoria de cada execução de IA do escritório.',
  SUBTITLE_AUTOR: 'Auditoria das suas execuções de IA.',
  COL_DATA: 'Data / hora',
  COL_AGENTE: 'Agente',
  COL_PROFISSIONAL: 'Profissional',
  COL_CANAL: 'Canal',
  COL_STATUS: 'Status',
  COL_TOKENS: 'Tokens',
  // ★ spec-006 (US-4): os rótulos passaram de `Custo`/`Créditos` para `Custo AAWZ`/
  // `Cobrado` porque a RELAÇÃO entre as duas colunas mudou. Até a base única de
  // cobrança, `Créditos` era sempre `2 × Custo` e a tabela se explicava sozinha;
  // agora um run em haiku custa R$ 0,108250 à AAWZ e cobra 0,433000 do consultor —
  // razão 4, não 2, porque o preço do cliente passou a sair de um modelo-base fixo
  // (ADR-016). Dois números de dinheiro lado a lado numa razão que não fecha se leem
  // como erro de cálculo; o rótulo diz DE QUEM é cada um, e a tooltip diz por quê.
  COL_CUSTO: 'Custo AAWZ',
  COL_CREDITOS: 'Cobrado',
  COL_CUSTO_TOOLTIP:
    'O que a AAWZ pagou ao provedor de IA por esta execução, no modelo que realmente rodou.',
  // ★ spec-006 T016 (G-17 do QA, [US-5]): "custou zero" e "não sabemos quanto custou" são
  // fatos diferentes. Quando o ledger registrou o custo como DESCONHECIDO (`custo_origem`
  // NULL), a célula mostra o traço — `R$ 0,00` ali afirmaria um custo que ninguém mediu,
  // que é o defeito que a spec-006 existe para impedir.
  // ★ spec-006 T017 (G-18): a copy diz SÓ o que vale em todos os casos — a origem do
  // consumo não informou o custo. O desconhecido cobre modelo sem preço confirmado E fonte
  // que mandou custo vazio para um modelo COM preço de tabela (runs `claude-sonnet-5`);
  // atribuir a causa ao "preço pendente" era falso no segundo caso.
  CUSTO_DESCONHECIDO: '—',
  CUSTO_DESCONHECIDO_TOOLTIP:
    'Custo desconhecido: a origem deste consumo não informou quanto a AAWZ pagou ao provedor. Não é custo zero.',
  CUSTO_DESCONHECIDO_ARIA: 'Custo AAWZ desconhecido: não informado pela origem',
  CUSTO_DESCONHECIDO_LEGENDA:
    'O traço (—) em Custo AAWZ indica custo não informado pela origem do consumo — nunca custo zero.',
  COL_CREDITOS_TOOLTIP:
    'O que foi debitado dos créditos do consultor. Desde a base única de cobrança o preço não depende do modelo usado, então este valor e o Custo AAWZ não são proporcionais.',
  CREDITOS_NAO_DEBITADO: CREDITOS_NAO_DEBITADO,
  // Débito real abaixo de um centésimo de crédito. Arredondar para `0,00` exibiria como
  // grátis uma cobrança que existiu — é erro de exibição, não economia de espaço.
  CREDITOS_SUBCENTAVO: CREDITOS_SUBCENTAVO,
  CREDITOS_LEGENDA:
    'Custo AAWZ é o que a AAWZ pagou ao provedor; Cobrado é o que saiu dos créditos do consultor. Os dois não são proporcionais: o preço do consultor não depende do modelo usado. Execução sem lançamento aparece como "não debitado" — nunca como 0,00.',
  // Linha vinda de `aawz_ai_usage` (copiloto, documentos, comitê): é uma chamada de
  // modelo já concluída, sem trilha de steps para abrir. Dizer isso é melhor do que
  // deixar o clique não fazer nada — ou abrir um "Execução não encontrada".
  SEM_TRILHA_LEGENDA:
    'Execuções do copiloto e das automações mostram custo e créditos, mas não têm linha do tempo para abrir.',
  EMPTY_FILTROS: 'Nenhuma execução encontrada para os filtros selecionados.',
  DRILL_TIMELINE: 'Linha do tempo',
  DRILL_COMPOSICAO: 'Composição do agente',
  DRILL_AGUARDANDO_DECISAO: 'Aguardando decisão de um gestor',
  DRILL_VER_CHANGELOG: 'Ver no registro de alterações',
  NOT_FOUND: 'Execução não encontrada.',
  // Rótulo do filtro de período no popover "Filtros" do header (era literal na view).
  FILTER_PERIODO: 'Período',
  // ★ Para quem NÃO é interno a coluna Custo AAWZ não existe — a tooltip e a legenda do
  // Cobrado não podem citar um custo que a tela não mostra (e que é informação interna).
  COL_CREDITOS_TOOLTIP_CONSULTOR: 'O que foi debitado dos créditos do consultor nesta execução.',
  CREDITOS_LEGENDA_CONSULTOR:
    'Cobrado é o que saiu dos créditos do consultor. Execução sem lançamento aparece como "não debitado" — nunca como 0,00.',
}

export const RUN_STATUS_LABELS = {
  running: 'Em andamento',
  completed: 'Concluída',
  failed: 'Falhou',
  awaiting_approval: 'Aguardando aprovação',
}

export const USAGE = {
  TITLE: 'Uso & Consumo',
  // Cobre as DUAS fontes de consumo (agentes do catálogo + copiloto/automações),
  // por isso "de IA" e não "dos agentes" — ver `core/consumo_ia.py`.
  SUBTITLE: 'Execuções, tokens e custo de IA do escritório.',
  ATUALIZADO_ATE: (data) => `Atualizado até ${data}.`,
  KPI_EXECUCOES: 'Execuções',
  KPI_TOKENS: 'Tokens',
  KPI_CUSTO: 'Custo (est.)',
  KPI_AGENTES: 'Agentes ativos',
  CHART_SERIE: 'Execuções por dia',
  CHART_BREAKDOWN: 'Consumo por agente',
  TABLE_TITLE: 'Custo por agente',
  COL_EXECUCOES: 'Execuções',
  COL_TOKENS: 'Tokens',
  COL_CUSTO_MES: 'Custo (mês)',
  COL_PARTICIPACAO: 'Participação',
  TOTAL: 'TOTAL',
  EMPTY_PERIODO: 'Nenhuma execução no período selecionado.',
}

// spec-001 project-ia-payment (Saldo de créditos) — card `saldo-creditos` (US-1).
// 1 crédito = R$ 1,00. O arredondamento é SÓ de exibição (ADR-007): o valor guardado tem 6
// casas e chega como string. ★ Saldo negativo NÃO pode ser comunicado só por cor (NFR de
// acessibilidade da spec) — daí `NEGATIVO_TAG` existir como TEXTO, e não só um estilo.
export const CREDITOS = {
  TITULO: 'Meus créditos',
  // Cabeçalho da área de créditos (`/central-ia/creditos`, US-1). O card diz "Meus
  // créditos"; a página não repete o "Meus" — o subtítulo é quem explica a unidade,
  // porque "crédito" só significa algo depois de ancorado no real (1 crédito = R$ 1,00).
  PAGINA_TITULO: 'Créditos',
  PAGINA_SUBTITULO:
    'Os créditos custeiam suas conversas com os agentes e seus ensaios por voz. 1 crédito equivale a R$ 1,00.',
  // ADR-011: enquanto uma superfície de consumo não debita, a tela precisa dizer isso.
  // Saldo que ignora um consumo mente por omissão — é o risco Alto/Alta do planning.
  NOTA_ESCOPO:
    'Conversas com agentes e ensaios por voz descontam créditos. O copiloto ainda não é cobrado.',
  UNIDADE: 'créditos',
  EQUIVALENTE: (valor) => `Equivale a ${valor}`,
  ATUALIZADO_EM: (data) => `Atualizado em ${data}`,
  // spec-005 [T029]: a parcela do saldo que vem do PLANO e vence no fim do ciclo. Fica no
  // card do saldo — e não só na tela de planos — porque é ali que o consultor olha para
  // decidir se pode gastar. Só aparece quando o backend manda `a_expirar`: sem ciclo
  // aberto os dois campos vêm `null`, e uma linha "0,00 expiram" seria ruído.
  A_EXPIRAR: (creditos, data) => `${creditos} expiram em ${data}`,
  A_EXPIRAR_AJUDA: 'São os créditos do seu plano. Os comprados avulsos não expiram.',
  NEGATIVO_TAG: 'Saldo negativo',
  // ADR-010: saldo negativo não bloqueia nada — a copy precisa dizer isso, senão o
  // consultor lê o vermelho como "fui cortado" e abre chamado.
  NEGATIVO_AJUDA:
    'O uso de IA continua liberado. O valor negativo é descontado dos próximos créditos adicionados.',
  SEM_PERMISSAO:
    'Você não tem permissão para ver o saldo deste profissional. Fale com um gestor do escritório.',
  INDISPONIVEL:
    'Não foi possível carregar seu saldo agora. Atualize a página ou tente novamente mais tarde.',
  // Atalho do rodapé da sidebar do chat (home por IA). Rótulo em 1ª pessoa, igual ao
  // card: é a carteira DELE, não um relatório do escritório.
  RODAPE_ATALHO: 'Ver meus créditos',
  // Curto de propósito — o espaço é de uma linha. A explicação inteira do porquê fica
  // na tela de créditos, para onde este atalho leva.
  RODAPE_INDISPONIVEL: 'Indisponível',
  ARIA_SALDO: (valor) => `Saldo de créditos: ${valor}`,
  ARIA_SALDO_NEGATIVO: (valor) => `Saldo de créditos negativo: ${valor}`,
  // Nome acessível do atalho do rodapé: ele é UM link que carrega DUAS informações, e o
  // leitor de tela precisa das duas. Só "Saldo de créditos: 119,57" não diz que clicar
  // leva a algum lugar; só "Ver meus créditos" esconde o número que está escrito ao lado
  // — e, na régua recolhida, esconde a única informação da linha.
  RODAPE_ARIA: (saldoFalado) => `Ver meus créditos. ${saldoFalado}`,
  // Item "Meus créditos" do palette (Ctrl+K da home por IA), segundo ponto de entrada do
  // modal. A descrição mostra o saldo quando há número confirmado — mesma regra do
  // rodapé: sem ele, diz o que o item faz em vez de inventar "0,00".
  PALETTE_DESCRICAO: 'Saldo, compra e uso de créditos',
  PALETTE_SALDO: (valorFalado) => `Saldo: ${valorFalado}`,
  // Saldo BAIXO (`utils/creditos.js::saldoBaixo`): o aviso antes de acabar, na linha do
  // hint do composer e no rodapé da lateral. Curto e sutil de propósito — a estimativa
  // "restam ~N perguntas" saiu a pedido do usuário (14/09/2026).
  SALDO_BAIXO_TITULO: 'Créditos acabando',
  SALDO_BAIXO: 'Créditos acabando',
  // A FAIXA acima do composer (15/09/2026): fechável, some por 7 dias
  // (`utils/dispensa-do-aviso-de-saldo-baixo.js`).
  SALDO_BAIXO_AVISO: 'Seus créditos estão acabando. Recarregue para não interromper o trabalho.',
  SALDO_BAIXO_FECHAR: 'Fechar aviso',
}

// spec-002 project-ia-payment (Compra de créditos) — componente `pacotes-creditos` (US-1).
// ★ O valor personalizado é digitado em REAIS INTEIROS e convertido para centavos com
// `* 100`: inteiro × 100 é exato em JS, enquanto ler reais com centavos do teclado abriria
// a porta para `12.34 * 100 === 1233.9999999999998` no meio de uma trilha de dinheiro.
// ★ Nenhum número aqui é somado no cliente: `creditos_totais` (base + bônus) vem calculado
// do servidor — somar no front é como o protótipo produz um total que ninguém revalida
// (`CONTRATO-PROTOTIPO.md` §3, `credits-screen.tsx:33`).
export const PACOTES = {
  TITULO: 'Adicionar créditos',
  SUBTITULO:
    'Escolha um pacote ou informe outro valor. O pagamento é por cartão, no ambiente da Stripe.',
  // Etiqueta comercial do pacote (`Teste`, `Popular`, `Melhor valor`, `Maior volume`) vem
  // do backend — o front nunca inventa etiqueta nem reordena o catálogo.
  // ★ `BONUS_TAG` foi REMOVIDA na spec-005 [T030]: o catálogo avulso é 1:1 desde a v658 e
  // o bônus é característica do PLANO. Copy de bônus parada aqui é a semente da promessa
  // que ninguém cumpre — o selo do plano vive em `PLANOS.BONUS_TAG`.
  VALOR_A_PAGAR: 'Você paga',
  TOTAL_CREDITOS: 'Você recebe',
  UNIDADE: 'créditos',
  PERSONALIZADO_TITULO: 'Outro valor',
  PERSONALIZADO_LABEL: 'Quanto quer adicionar',
  // ★ A frase perdeu o "Esta opção não concede bônus" na spec-005 [T030]: com o catálogo
  // 1:1, dizer que ESTA opção não dá bônus insinua que as outras dão — a mesma promessa
  // morta que o selo dos cards carregava. `SEM_BONUS` foi removida pelo mesmo motivo.
  PERSONALIZADO_AJUDA: (minimo, maximo) =>
    `Valor inteiro em reais, de ${minimo} a ${maximo}.`,
  // A MESMA ajuda quando "Outro valor" é um CARD da grade (página, `outroValorComoCard`):
  // ali ela é o texto auxiliar abaixo do campo, e a forma curta cabe na largura do card.
  PERSONALIZADO_AJUDA_CARD: (minimo, maximo) => `De ${minimo} a ${maximo}, em valor inteiro`,
  // Subtítulo da aba Adicionar na PÁGINA: a Stripe já é citada no rodapé da aba; o que
  // vale dizer aqui é a diferença de fundo entre avulso e plano (o avulso não expira).
  SUBTITULO_PAGINA: 'Escolha um pacote ou informe outro valor. Créditos avulsos não expiram.',
  // Cita o valor recebido E o intervalo aceito (US-1) — mensagem que só diz "valor
  // inválido" obriga o consultor a adivinhar qual dos dois lados ele estourou.
  FORA_DOS_LIMITES: (valor, minimo, maximo) =>
    `${valor} está fora do intervalo aceito. Informe um valor inteiro entre ${minimo} e ${maximo}.`,
  CTA: 'Ir para o pagamento',
  CTA_AJUDA: 'Você será levado ao ambiente de pagamento da Stripe para concluir a compra.',
  ERRO_CATALOGO:
    'Não foi possível carregar os pacotes de créditos agora. Tente novamente em alguns instantes.',
  ERRO_CATALOGO_CTA: 'Tentar novamente',
  // US-1: catálogo vazio é ESTADO VAZIO, nunca um catálogo hardcoded no cliente.
  VAZIO_TITULO: 'Nenhum pacote disponível',
  VAZIO_TEXTO:
    'O catálogo de créditos está sem pacotes vigentes no momento. Fale com o suporte da AAWZ.',
  // Falha ao abrir a cobrança ([T023]). A mensagem preferida é a do backend (`r.message`);
  // esta é o piso para quando a requisição nem chega a ter corpo (rede caiu).
  ERRO_CHECKOUT:
    'Não foi possível iniciar o pagamento agora. Tente novamente em alguns instantes.',
  // ★ Só existe no 502 do contrato: ali o pagamento FOI criado e ficou em `falhou`, e este
  // id é o ponto de partida do suporte para "paguei e não caiu". Em erro de validação não
  // há pagamento nenhum — e um protocolo inventado mandaria o suporte procurar o que não
  // existe.
  CHECKOUT_PROTOCOLO: (id) => `Protocolo para o suporte: ${id}`,
  // Destino recusado pela guarda de host: a URL não é do checkout da Stripe. O consultor
  // precisa saber que o clique foi barrado de propósito — sair em silêncio deixaria a
  // impressão de botão quebrado — e qual é o próximo passo.
  ERRO_CHECKOUT_DESTINO:
    'O endereço de pagamento devolvido não é o do checkout da Stripe e foi bloqueado por segurança. Tente novamente ou contate o suporte.',
  ARIA_LISTA: 'Pacotes de créditos',
  ARIA_PACOTE: (valor, creditos) => `Pacote de ${valor}, ${creditos} créditos`,
  ARIA_PERSONALIZADO: 'Outro valor de créditos',
}

// Modal centralizado de créditos (`modal/creditos-modal`) — abre de dentro do chat, sem
// sair da página. Três abas: Planos (vitrine, sem backend), Adicionar créditos (reusa o
// catálogo REAL de `pacotes-creditos`) e Uso (reusa os indicadores e o extrato da tela de
// Execuções, escopados ao próprio profissional).
export const CREDITOS_MODAL = {
  TITULO: 'Créditos',
  // O título do header acompanha a aba (`tituloDaAba` em `creditos-modal.vue`).
  TITULO_POR_ABA: { planos: 'Planos', adicionar: 'Créditos', uso: 'Uso' },
  SUBTITULO: CREDITOS.PAGINA_SUBTITULO,
  ARIA: 'Créditos de IA',
  FECHAR: 'Fechar',
  // Chip do saldo no cabeçalho — mesmo rótulo do rodapé da lateral (`CREDITOS.TITULO`).
  SALDO_LABEL: CREDITOS.TITULO,
  SALDO_INDISPONIVEL: CREDITOS.RODAPE_INDISPONIVEL,

  ABA_PLANOS: 'Planos',
  ABA_ADICIONAR: 'Adicionar créditos',
  ABA_USO: 'Uso',

  // A aba Planos usa a copy dos próprios componentes (`PLANOS`, `ASSINATURA`).

  // ── Aba Adicionar créditos ──
  ADICIONAR_TITULO: PACOTES.TITULO,
  ADICIONAR_SUBTITULO: PACOTES.SUBTITULO,
  CONTINUAR: (valor) => `Continuar · ${valor}`,
  // O mesmo CTA na PÁGINA: lá a compra não tem "próxima etapa" dentro da tela, e o botão
  // nomeia a ação.
  COMPRAR: (valor) => `Comprar · ${valor}`,
  ESCOLHA_UM_VALOR: 'Escolha um valor',

  // ── Rodapé (só a aba Adicionar tem rodapé) ──
  NOTA_ADICIONAR: PACOTES.CTA_AJUDA,
}

// Cabeçalho da PÁGINA `/central-ia/creditos` (protótipo v2), no header da nav-bar: só o
// botão que leva à aba Adicionar. (O card "MEUS CRÉDITOS | PLANO" que ficava ao lado saiu
// em 13/09/2026 — os rótulos dele saíram junto.)
export const CREDITOS_PAGINA = {
  CTA_ADICIONAR: CREDITOS_MODAL.ABA_ADICIONAR,
}

// spec-002 project-ia-payment (Compra de créditos) — view `creditos-pagamento` (US-2, US-3,
// US-5). ★ O ramo da tela é decidido pelo ESTADO INTERNO (`status_pagamento`), nunca pelo
// rótulo: rótulo é texto de exibição e mudaria a tela inteira se alguém corrigisse um acento.
// ★ Cada ramo carrega TEXTO próprio — o protótipo pinta todos os status com a mesma cor
// (`CONTRATO-PROTOTIPO.md:156`), o que faz um pagamento pendente parecer aprovado.
export const PAGAMENTO = {
  PAGINA_TITULO: 'Pagamento de créditos',
  VOLTAR: 'Voltar para créditos',
  // Rótulo de cada estado interno. As seis chaves de `data-model.md §5` mais `criado`,
  // que compartilha o rótulo de `aguardando_pagamento` — para quem olha a tela, "criado"
  // e "aguardando" são o mesmo fato: ainda não terminou.
  ROTULOS: {
    criado: 'Processando',
    aguardando_pagamento: 'Processando',
    pago: 'Aprovado',
    falhou: 'Não autorizado',
    expirado: 'Expirado',
    estornado: 'Estornado',
    contestado: 'Em análise',
  },
  DESCRICOES: {
    criado: 'Estamos confirmando seu pagamento com a Stripe. Nada foi creditado ainda.',
    aguardando_pagamento:
      'Estamos confirmando seu pagamento com a Stripe. Nada foi creditado ainda.',
    pago: 'Pagamento confirmado. Os créditos já estão na sua carteira.',
    falhou:
      'O pagamento não foi autorizado e nenhum crédito foi adicionado. Você pode tentar de novo com outro cartão.',
    expirado:
      'A sessão de pagamento expirou antes da conclusão e nenhum valor foi cobrado. Comece uma nova compra quando quiser.',
    estornado:
      'O valor foi estornado e os créditos correspondentes foram retirados da carteira.',
    contestado:
      'Este pagamento está em análise com a operadora do cartão. Nossa equipe já foi avisada e o saldo segue inalterado.',
  },
  ICONES: {
    criado: 'clock',
    aguardando_pagamento: 'clock',
    pago: 'check-circle',
    falhou: 'close-circle',
    expirado: 'timer-warning',
    estornado: 'repeat-circle',
    contestado: 'warning-status',
  },
  // Cor do ÍCONE de cada ramo — tokens de texto legível do DS (`_controls.sass:31-35`),
  // nunca hex. A cor é reforço da palavra e da forma do ícone, jamais o único canal: o
  // rótulo em texto continua ali para quem não distingue as duas.
  ICONE_CORES: {
    criado: 'warning-text-strong',
    aguardando_pagamento: 'warning-text-strong',
    pago: 'success-text',
    falhou: 'danger-text',
    expirado: 'danger-text',
    estornado: 'danger-text',
    contestado: 'warning-text-strong',
  },
  // ★ Estado que o backend passe a emitir e o front ainda não conheça cai no ramo
  // `aguardando_pagamento` ("Processando"), NUNCA em `pago`: o desconhecido é tratado como
  // "ainda não terminou". Pintar de verde um estado que ninguém mapeou é o pior defeito
  // possível nesta tela — foi assim que o protótipo fez um pendente parecer aprovado.
  STATUS_DESCONHECIDO_FALLBACK: 'aguardando_pagamento',
  RECIBO_TITULO: 'Recibo',
  RECIBO_VALOR: 'Valor pago',
  RECIBO_CREDITOS: 'Créditos adicionados',
  RECIBO_BONUS: 'Bônus',
  RECIBO_TOTAL: 'Total de créditos',
  RECIBO_METODO: 'Forma de pagamento',
  RECIBO_CONFIRMADO_EM: (data) => `Confirmado em ${data}`,
  // O método chega como {tipo, brand, last4} — quem concatena é a tela (contrato api.md);
  // o backend nunca manda a string pronta.
  // A bandeira chega em minúsculas da Stripe ('visa'); quem apresenta é a tela.
  METODO_CARTAO: (bandeira, digitos) => `${bandeira} •••• ${digitos}`,
  METODO_GENERICO: 'Cartão',
  // O saldo do recibo é o do card `saldo-creditos`, RELIDO do backend. Nunca a soma
  // `saldo anterior + créditos comprados` feita no cliente.
  SALDO_TITULO: 'Seu saldo agora',
  ATUALIZAR: 'Atualizar',
  // Polling com TETO (nunca laço infinito): ao esgotar as tentativas a tela para e passa o
  // controle para o consultor, em vez de girar para sempre consumindo bateria e requisição.
  TETO_ATINGIDO:
    'A confirmação está demorando mais que o normal. Ela continua em andamento — atualize para ver o estado mais recente.',
  ERRO: 'Não foi possível carregar este pagamento. Ele pode não existir ou não ser seu.',
  MOTIVO_FALHA: (mensagem) => `Motivo: ${mensagem}`,
  ARIA_STATUS: (rotulo) => `Estado do pagamento: ${rotulo}`,
}

// spec-003 project-ia-payment (Extrato e custo por pergunta) — faixa de indicadores da
// tela de Execuções (`creditos-kpi-strip`, US-2/US-3).
//
// ★ Os dois cards falam do MESMO recorte da tabela abaixo (um período governa a tela
// inteira, US-3) — por isso cada card carrega o escopo por escrito: de QUEM é o número e
// QUAL período ele cobre. Total sem recorte declarado é número sem unidade.
export const CREDITOS_RESUMO = {
  KPI_CONSUMIDOS: 'Créditos consumidos',
  KPI_TOTAL_PAGO: 'Total pago',
  // Rótulo do dono quando o número é do próprio solicitante — o caso do consultor e o do
  // gestor com o filtro de profissional em "Todos" (US-2: nesse caso o agregado é o DELE,
  // e o rótulo precisa dizer isso, senão ele lê o consumo próprio como o do escritório).
  DONO_PROPRIO: 'Você',
  // Gestor que filtrou por um profissional cujo nome ainda não apareceu em nenhuma linha
  // da página: o rótulo NÃO cai para "Você" — dizer que o número é seu quando é de outra
  // pessoa é pior do que não nomear a pessoa.
  DONO_OUTRO_SEM_NOME: 'Profissional selecionado',
  PERIODO: (de, ate) => `${de} a ${ate}`,
  ESCOPO: (dono, periodo) => `${dono} · ${periodo}`,
  // Enquanto `compra_disponivel` for `false` o card NÃO é escondido: esconder faria o
  // consultor procurar onde compra. O card fica, com a nota dizendo o estado real.
  COMPRA_INDISPONIVEL: 'A compra de créditos ainda não está disponível.',
  // ★ Falha de leitura NÃO vira `0,00`: zero é uma afirmação ("você não consumiu nada"),
  // e afirmar isso a partir de uma requisição que não voltou é a mesma mentira que o
  // `0,00` conta na coluna de um run não debitado.
  INDISPONIVEL:
    'Não foi possível carregar os indicadores do período. Atualize a página ou tente novamente mais tarde.',
  ARIA: 'Indicadores de créditos do período',
}

// spec-003 project-ia-payment (US-4) — extrato do ledger na tela de Execuções
// (`creditos-extrato-lista`).
//
// ★ O extrato explica o SALDO INTEIRO, não só a metade que sai: lista todas as naturezas
// e o SINAL vem do valor do lançamento, nunca da seção/aba em que a linha aparece.
// ★ Sem método e sem status de pagamento: esses dois campos NÃO existem no ledger — eles
// nascem com a tabela de pagamentos da spec-002. Exibi-los aqui seria fabricar dado.
// Contagem das réguas no título do aviso: por extenso até três, em algarismo depois.
const FORMAS_POR_EXTENSO = { 2: 'Duas', 3: 'Três' }
export const CREDITOS_EXTRATO = {
  TITULO: 'Movimentações de créditos',
  SUBTITULO:
    'Entradas e saídas da carteira no mesmo período selecionado acima. O valor cobrado vem do extrato, não de um cálculo da tela.',
  FILTRO_NATUREZA: 'Tipo',
  TODAS_LABEL: 'Todas',
  COL_DATA: 'Data / hora',
  COL_TIPO: 'Tipo',
  COL_DESCRICAO: 'Descrição',
  COL_CREDITOS: 'Créditos',
  // Lançamento de run cujo agente foi removido do catálogo: a linha continua íntegra e
  // identificada pela natureza da referência — o extrato não some por falta de nome.
  RUN_SEM_AGENTE: 'Execução de agente',
  NATUREZA_LABELS: {
    consumo: 'Consumo',
    compra: 'Compra',
    bonus: 'Bônus',
    ajuste: 'Ajuste',
    estorno: 'Estorno',
    // A natureza que a spec-005 acrescentou: o crédito do PLANO que venceu sem ser
    // usado. Sem esta entrada o extrato mostrava o enum cru ('expiracao', minúsculo
    // e sem acento) e o filtro não oferecia a opção — o consultor não conseguia
    // filtrar justamente o lançamento que tirou os créditos dele.
    expiracao: 'Expiração',
  },
  // ★ Terceiro canal do sinal, além da cor e da posição: SÍMBOLO em texto. Cor sozinha
  // não sobrevive a daltonismo nem a impressão em P&B. O `−` é o sinal de menos
  // tipográfico (U+2212), não o hífen: em fonte proporcional o hífen encolhe a ponto de
  // sumir ao lado do dígito.
  SUBCENTAVO: CREDITOS_SUBCENTAVO,
  // Mesma copy da coluna Créditos do log — e agora a MESMA função de exibição
  // (`@modules/ai-framework/utils/creditos`), para as duas não voltarem a divergir.
  NAO_DEBITADO: CREDITOS_NAO_DEBITADO,
  SINAL_ENTRADA: '+',
  SINAL_SAIDA: '−',
  // Palavra por extenso para leitor de tela (o símbolo é lido de forma inconsistente).
  ARIA_ENTRADA: (valor) => `Entrada de ${valor} créditos`,
  ARIA_SAIDA: (valor) => `Saída de ${valor} créditos`,
  // Lançamento sem valor numérico: não há entrada nem saída para anunciar, e um "+"
  // lido em voz alta afirmaria um crédito recebido que não existe.
  ARIA_NAO_DEBITADO: `Lançamento ${CREDITOS_NAO_DEBITADO}`,
  // 403 do módulo: resposta AUTORITATIVA de indisponibilidade. Sem copy própria, a lista
  // vazia do 403 se leria como "você não movimentou nada" — o mesmo tipo de mentira que
  // `0,00` conta na coluna de um run não debitado.
  SEM_ACESSO:
    'As movimentações de créditos não estão disponíveis para este escritório. Fale com um gestor.',
  // ★ spec-006 [US-4]/[US-8] — o aviso da fronteira entre réguas de cobrança.
  // Ele existe porque o extrato passou a listar, lado a lado, lançamentos
  // cobrados por réguas diferentes: antes da base única o preço variava com o
  // modelo, depois passou a sair de um modelo-base fixo. Sem dizer isso, a
  // mudança no valor cobrado entre duas linhas parecidas se lê como erro.
  // Só aparece quando o período REALMENTE atravessa uma troca — aviso em toda
  // tela treina o leitor a ignorá-lo ([US-4] AC-3).
  // O título conta as MESMAS réguas que a lista logo abaixo nomeia. Com a 2ª troca de base
  // são três (`spec.md:225`), e "Duas formas" sobre uma lista de três era o texto
  // desmentindo o dado. Singular não ocorre: o aviso só existe com mais de uma régua. Abaixo
  // de duas (`regua_mudou_no_periodo` sem a lista, payload inconsistente), não inventa número.
  REGUA_MUDOU_TITULO: (n) => {
    if (!(n >= 2)) return 'Mais de uma forma de cobrança neste período'
    return `${FORMAS_POR_EXTENSO[n] || n} formas de cobrança neste período`
  },
  REGUA_MUDOU_TEXTO: (quando) =>
    `A partir de ${quando}, o valor cobrado deixou de variar com o modelo de IA usado e passou a sair de uma base única. Lançamentos anteriores a essa data seguem com a cobrança antiga — nenhum deles foi recalculado.`,
  // Rótulo do lançamento cujo `modelo_base_cobranca` é `null`: ele é anterior à
  // base única. O servidor manda `null` de propósito e quem nomeia é a tela.
  REGUA_ANTERIOR: 'Cobrança anterior à base única',
  REGUA_LANCAMENTOS: (n) => (n === 1 ? '1 lançamento' : `${n} lançamentos`),
  // Um item da lista de réguas: "claude-sonnet-5 — desde 05/09/2026 14h32, 3 lançamentos".
  REGUA_LINHA: (rotulo, desde, lancamentos) => `${rotulo} — desde ${desde}, ${lancamentos}`,
  PAGINACAO_ANTERIOR: 'Anterior',
  PAGINACAO_PROXIMA: 'Próxima',
  VAZIO_TITULO: 'Nenhuma movimentação no período',
  // A ausência é EXPLICADA: sem isto, uma tabela vazia se lê como defeito da tela.
  VAZIO_TEXTO:
    'Consumos de IA aparecem aqui assim que houver execução cobrada. As entradas de compra e bônus passam a ser listadas quando a compra de créditos for liberada.',
  ERRO:
    'Não foi possível carregar as movimentações do período. Atualize a página ou tente novamente mais tarde.',
  ARIA_LISTA: 'Movimentações de créditos do período',
}

// Aba Uso do modal de créditos (`components/creditos-uso-painel` +
// `components/creditos-grafico-diario`). Escopo: SEMPRE o próprio profissional.
// ★ A legenda dos KPIs é o período, não "18% acima do mês anterior": comparar com o
// período anterior exigiria um segundo `carregarResumo`, e o slice `resumo` é ÚNICO no
// store — a segunda leitura sobrescreveria a primeira.
export const CREDITOS_USO = {
  TITULO: 'Consumo e movimentações',
  // `01/09 a 30/09 · últimos 30 dias`
  PERIODO: (de, ate, descricao) => `${de} a ${ate} · ${descricao}`,
  PERIODO_30: '30 dias',
  PERIODO_90: '90 dias',
  PERIODO_ANO: 'Ano',
  PERIODO_DESCRICAO_30: 'últimos 30 dias',
  PERIODO_DESCRICAO_90: 'últimos 90 dias',
  PERIODO_DESCRICAO_ANO: 'ano corrente',
  ARIA_PERIODO: 'Período do consumo',

  KPI_CONSUMIDOS: CREDITOS_RESUMO.KPI_CONSUMIDOS,
  KPI_TOTAL_PAGO: CREDITOS_RESUMO.KPI_TOTAL_PAGO,
  // Legenda dos dois cards: o recorte, por escrito (total sem período é número sem unidade).
  KPI_LEGENDA: (de, ate) => `De ${de} a ${ate}`,
  KPI_INDISPONIVEL: CREDITOS_RESUMO.INDISPONIVEL,
  // ── Os dois KPIs a mais da PÁGINA (`larguraTotal`), derivados do que já está na tela:
  // média = consumidos ÷ dias do período; "acaba em" = hoje + saldo ÷ média. São as ÚNICAS
  // contas do painel, e são projeção (a copy diz), não fato do ledger. O que o dado NÃO
  // sustenta fica de fora: "% acima do período anterior" (o slice `resumo` é único) e
  // "N compras" (`resumo` não devolve contagem).
  KPI_MEDIA_DIA: 'Média por dia',
  KPI_SALDO_ACABA: 'Saldo acaba em',
  KPI_PICO: (valor, dia) => `Pico de ${valor} em ${dia}`,
  KPI_SEM_CONSUMO: 'sem consumo no período',
  KPI_PROJECAO: 'projeção pelo ritmo atual',
  KPI_SEM_SALDO: 'sem saldo disponível',
  // Sem número a afirmar (média zero, saldo ausente): um travessão, nunca "0" nem uma data.
  KPI_INDEFINIDO: '—',

  GRAFICO_TITULO: 'Consumo por dia',
  // Canto direito do card na PÁGINA (o pico já está no KPI "Média por dia").
  GRAFICO_UNIDADE: 'em créditos',
  // No período "Ano" cada barra é uma semana (`agruparPorSemana`).
  GRAFICO_TITULO_SEMANA: 'Consumo por semana',
  GRAFICO_PICO: (valor, dia) => `Pico ${valor} em ${dia}`,
  GRAFICO_VAZIO: 'Sem consumo no período',
  GRAFICO_ARIA: (valor, dia) => `Consumo de créditos por dia. Pico de ${valor} em ${dia}.`,
  GRAFICO_BARRA: (dia, valor) => `${dia} · ${valor} créditos`,
  // Rótulo de uma barra semanal: `01/09 a 07/09`.
  GRAFICO_INTERVALO: (de, ate) => `${de} a ${ate}`,
  GRAFICO_SERIE: 'Créditos consumidos',

  MOVIMENTACOES_TITULO: 'Movimentações',
  FILTRO_TODAS: CREDITOS_EXTRATO.TODAS_LABEL,
  ARIA_FILTRO: 'Tipo de movimentação',
  COL_DATA: 'Data',
  // Na PÁGINA (largura total) a coluna tem espaço para o nome inteiro e ganha a de agente
  // (`agente_nome`, que o extrato só traz em lançamento de run — os demais mostram `—`).
  COL_DATA_HORA: CREDITOS_EXTRATO.COL_DATA,
  COL_AGENTE: 'Agente',
  AGENTE_VAZIO: '—',
  COL_TIPO: CREDITOS_EXTRATO.COL_TIPO,
  COL_DESCRICAO: CREDITOS_EXTRATO.COL_DESCRICAO,
  COL_CREDITOS: CREDITOS_EXTRATO.COL_CREDITOS,
  MOSTRANDO: (exibidas, total) => `Mostrando ${exibidas} de ${total} movimentações`,
  VER_EXTRATO_COMPLETO: 'Ver extrato completo',
  MOVIMENTACOES_VAZIO: CREDITOS_EXTRATO.VAZIO_TITULO,
  // Filtro que não casa nenhuma linha do extrato carregado — diferente de período vazio.
  FILTRO_VAZIO: 'Nenhuma movimentação desse tipo no período',
  SEM_ACESSO: CREDITOS_EXTRATO.SEM_ACESSO,
  ARIA_MOVIMENTACOES: CREDITOS_EXTRATO.ARIA_LISTA,

  RECIBOS_TITULO: 'Recibos',
  // Honesto: não existe listagem de pagamentos no cliente — só o comprovante de UM
  // pagamento, na tela de retorno da compra (`creditos/pagamento/:idPagamento`).
  RECIBOS_VAZIO:
    'A lista de recibos ainda não está disponível aqui. O comprovante de cada compra é exibido ao concluir o pagamento.',
}

// spec-005 project-ia-payment (Planos recorrentes) — componente `planos-creditos` (US-1).
//
// ★ TRÊS COPYS QUE EXISTEM PARA NÃO PRODUZIR RECLAMAÇÃO
//
// 1. **`EXPIRACAO_*` e `CREDITOS_NAO_ACUMULAM`.** O crédito do plano morre no fim de cada
//    ciclo mensal — é a decisão mais cara desta spec, e o consultor precisa lê-la ANTES de
//    assinar, não no extrato depois. É também a única diferença de fundo entre o plano e a
//    compra avulsa (que não expira), e por isso as duas coisas são ditas na mesma frase.
// 2. **`CREDITOS_POR_CICLO` fala em "por mês", inclusive no plano ANUAL.** O anual entrega
//    exatamente os mesmos créditos por ciclo que o mensal; o desconto está no PREÇO. Uma
//    copy que anunciasse o total do ano (`7.200 créditos`) mentiria duas vezes: o número
//    nunca existe de uma vez, e cada parcela dele expira no fim do seu mês.
// 3. **O selo do toggle NÃO carrega percentual.** O servidor deriva a economia em REAIS
//    (`economia_anual_centavos`) e o valor mensal equivalente, e é isso que os cards
//    mostram. Um "Economize 25%" seria aritmética de dinheiro feita no cliente — a mesma
//    classe de defeito que somar base + bônus aqui (ADR-007 e `contracts/api.md §1`).
// 4. **No anual, o DESTAQUE é o valor por mês** (`VALOR_SUFIXO.mensal`) e o cheio do
//    período vai para `COBRADO_ANUALMENTE` — os dois números já vêm do servidor; o que
//    muda é qual ocupa qual slot.
export const PLANOS = {
  TITULO: 'Planos de créditos',
  // Chamada de UMA linha do cabeçalho da grade (`creditos-planos-cards`), ao lado do toggle.
  CHAMADA: 'Assine um plano e receba créditos todo mês por menos',
  SUBTITULO:
    'Assine um plano e receba créditos todo mês. No plano anual, o mesmo volume de créditos sai por um preço menor.',
  TOGGLE_ARIA: 'Periodicidade do plano',
  TOGGLE_MENSAL: 'Mensal',
  TOGGLE_ANUAL: 'Anual',
  // Sem número: o desconto de cada família vem do servidor e aparece no card.
  ANUAL_SELO: 'Pague menos no anual',
  // O sufixo acompanha o número EXIBIDO, não a periodicidade do plano: o card anual mostra
  // o valor por mês em destaque, e "R$ 375,00 /ano" seria mentira.
  VALOR_SUFIXO: { mensal: '/mês', anual: '/ano' },
  COBRADO_ANUALMENTE: (valor) => `${valor} cobrados anualmente`,
  ECONOMIA_ANUAL: (valor) => `Economia de ${valor} por ano`,
  // A linha sob o preço do card ANUAL: "R$ 1.800,00 por ano · economia de R$ 600,00".
  ANO_LINHA: (valorAno, economia) =>
    economia ? `${valorAno} por ano · economia de ${economia}` : `${valorAno} por ano`,
  CREDITOS_POR_CICLO: (creditos) => `${creditos} créditos por mês`,
  // 2ª linha da caixa de créditos do card: "200 + 20 de bônus (10%)".
  COMPOSICAO_CREDITOS: (base, bonus, percentual) => `${base} + ${bonus} de bônus (${percentual})`,
  // ── Os itens do CARD (mockup do owner, 18/09/2026). A caixa cinza dos créditos saiu e
  // virou o PRIMEIRO item da lista, com a composição entre parênteses:
  // "220 créditos por mês (200 + 20 de bônus (10%))". O `total` e a `composicao` continuam
  // vindo do servidor (`utils/planos.js`) — aqui só a moldura.
  CREDITOS_ITEM: (creditos, composicao) =>
    composicao ? `${creditos} créditos por mês (${composicao})` : `${creditos} créditos por mês`,
  // ★ PROMESSA COMERCIAL, não fato do catálogo (mockup do owner, 18/09/2026).
  //
  // Diferente de todo o resto deste arquivo, estas frases NÃO são derivadas de nenhum
  // campo: o `beneficios` do backend (`usecase_creditos_planos._beneficios`) só produz
  // fatos (créditos, bônus, desconto anual, renovação, cancelamento) e o `beneficios`
  // jsonb da tabela está NULL nos 6 planos. Elas descrevem o que cada plano ENTREGA.
  //
  // ⚠️ Quem mudar preço, escopo de módulo ou o que um plano dá TEM de revisar esta lista —
  // ela é o que o consultor lê antes de pagar. Chaveada por `familia` (a coluna do
  // catálogo), não por `codigo`: mensal e anual da mesma família entregam o mesmo.
  // Starter tem 2 itens e os outros 3 — a assimetria é do mockup, não é bug.
  BENEFICIOS_POR_FAMILIA: {
    starter: ['Agentes de CRM, Consolidador e Tarefas', 'Ensaios por voz'],
    growth: [
      'Tudo do Starter',
      'Financial Planning e Compliance',
      'Relatórios enviados ao cliente',
    ],
    pro: ['Tudo do Growth', 'Prioridade em horários de pico', 'Suporte dedicado no WhatsApp'],
  },
  // A linha sob o preço. No anual o número em destaque é o valor POR MÊS, e esta linha diz
  // o que a fatura cobra de fato; no mensal não há parêntese a abrir.
  SUBLINHA_ANUAL: (valorAno) => `Por mês, cobrado anualmente (${valorAno})`,
  SUBLINHA_MENSAL: 'Por mês, cobrado mensalmente',
  // ── A nota institucional, UMA vez abaixo do catálogo (18/09/2026). Era a mesma lista de
  // três frases repetida nos 3 cards — a maior fonte de poluição da aba.
  //
  // ★ SEM PERCENTUAL, de propósito. O desconto anual não é campo do catálogo
  // (`CAMPOS_PUBLICOS` do usecase não o expõe); ele só existe dentro do texto de benefício
  // de cada plano, calculado no servidor. Escrever "25%" aqui seria uma segunda cópia do
  // número, e ela mente no dia em que um preço mudar — e derivá-lo no cliente
  // (`economia / (mensal × 12)`) seria aritmética de dinheiro no front, vetada no módulo.
  // O percentual exato continua no item do card, que vem do backend.
  NOTA_RODAPE_ANUAL:
    'Desconto em relação ao plano mensal. Créditos renovam todo mês; os não usados vencem no fim do ciclo. Ao cancelar, o plano segue até o fim do ano pago.',
  NOTA_RODAPE_MENSAL:
    'Créditos renovam todo mês; os não usados vencem no fim do ciclo. Ao cancelar, o plano segue até o fim do mês pago.',
  CREDITOS_NAO_ACUMULAM: 'Não acumulam: expiram no fim de cada mês',
  BONUS_TAG: (percentual) => `+${percentual} de bônus`,
  // ★ Terceiro canal do estado selecionado, além da borda e do fundo tingido: PALAVRA.
  SELECIONADO: 'Selecionado',
  PLANO_ATUAL: 'Seu plano atual',
  PLANO_ATUAL_AJUDA: 'Para trocar de plano, cancele o atual antes de assinar outro.',
  INDISPONIVEL: 'Indisponível',
  // Rótulo do botão desabilitado do card; o motivo longo (`INDISPONIVEL_AJUDA`) segue no
  // `aria-label` do card (`utils/planos.js`).
  INDISPONIVEL_CURTO: 'Indisponível no momento',
  INDISPONIVEL_AJUDA:
    'Este plano está temporariamente indisponível para contratação. Fale com o suporte da AAWZ.',
  EXPIRACAO_TITULO: 'Os créditos do plano expiram a cada ciclo',
  EXPIRACAO_TEXTO:
    'Todo mês entram novos créditos e os do ciclo anterior expiram — o que não for usado não acumula. Os créditos comprados avulsos não expiram.',
  CTA: 'Assinar plano',
  // Botão de cada card (seleciona) e os dois estados que não selecionam.
  ESCOLHER: (nome) => `Escolher ${nome}`,
  SELECIONADO_CTA: 'Plano selecionado',
  // Rodapé da aba Planos (mesmo desenho do rodapé de Adicionar créditos).
  NOTA_RODAPE: 'Pagamento por cartão, no ambiente da Stripe. Cancele quando quiser.',
  CONTINUAR: (nome) => `Continuar com ${nome}`,
  ESCOLHA_UM_PLANO: 'Escolha um plano',
  CTA_AJUDA:
    'Você será levado ao ambiente de pagamento da Stripe para concluir a assinatura.',
  ERRO_CATALOGO:
    'Não foi possível carregar os planos de créditos agora. Tente novamente em alguns instantes.',
  ERRO_CATALOGO_CTA: 'Tentar novamente',
  // US-1 AC-5: catálogo de planos vazio não esconde a compra avulsa — ela continua na tela.
  VAZIO_TITULO: 'Nenhum plano disponível',
  VAZIO_TEXTO:
    'Nenhum plano está vigente no momento. Você pode adicionar créditos avulsos logo abaixo.',
  ARIA_LISTA: 'Planos de créditos',
  // ── A TABELA de planos da PÁGINA (`creditos-planos-tabela`, protótipo v2). O modal
  // continua com os cards; os textos das colunas vêm do mesmo view-model dos cards.
  TABELA_CHAMADA: 'Assine um plano e receba créditos todo mês',
  // Sem percentual: o catálogo não expõe o desconto anual como campo (só dentro do texto
  // dos benefícios), e um "25%" escrito aqui seria número inventado.
  TABELA_SUBTITULO:
    'No anual você paga menos por mês. Os créditos avulsos continuam disponíveis a qualquer momento.',
  COL_PLANO: 'Plano',
  COL_PRECO: 'Preço',
  COL_CREDITOS: 'Créditos por mês',
  COL_CONDICOES: 'Condições',
  COL_ACAO: 'Ação',
  // "600 créditos" — a unidade sem o "por mês", que já é o título da coluna.
  CREDITOS_CURTO: (creditos) => `${creditos} créditos`,
  ASSINAR: (nome) => `Assinar ${nome}`,
  // ── Com plano ATIVO (protótipo v2, tabela E cards): o vigente leva o chip "SEU PLANO" e
  // o botão curto desabilitado; os outros dizem a DIREÇÃO da troca pelo valor mensal
  // equivalente (`acaoDoPlano`, `utils/planos.js`). O servidor ainda não troca de plano
  // (o POST com assinatura viva é 409): o clique mostra `PLANO_ATUAL_AJUDA` no snack.
  SEU_PLANO: 'Seu plano',
  PLANO_ATUAL_CURTO: 'Plano atual',
  UPGRADE: 'Fazer upgrade',
  TROCAR: (nome) => `Trocar para ${nome}`,
  // O rodapé do modal ("Continuar com {nome}") com as mesmas direções.
  UPGRADE_CONTINUAR: (nome) => `Fazer upgrade para ${nome}`,
  // Rodapé da tabela: o que o BENEFICIO_CANCELAMENTO do backend também diz, numa frase.
  NOTA_TABELA:
    'Pagamento por cartão, no ambiente da Stripe. Cancele quando quiser; o plano segue até o fim do período pago.',
  // `estado` é opcional (S9, review PR #2211): "Seu plano atual", "Indisponível" com o
  // motivo, ou a etiqueta comercial do backend — o que faz o card ficar fora de alcance
  // ou já contratado, em PALAVRA, para quem usa leitor de tela.
  ARIA_PLANO: (nome, valor, creditos, estado) =>
    `Plano ${nome}, ${valor}, ${creditos}` + (estado ? `, ${estado}` : ''),
}

// spec-005 project-ia-payment (Planos recorrentes) — `creditos-assinatura-card` e a
// confirmação de cancelamento (US-5).
//
// ★ O BLOCO DO CICLO É O TEXTO MAIS IMPORTANTE DESTA SPEC. "600 créditos deste ciclo ·
// 350 ainda disponíveis · expiram em 09/10/2026" é o que separa "o plano funciona" de "a
// plataforma comeu meu crédito": a expiração precisa estar visível ANTES de acontecer, e
// não só no extrato depois (R-7).
//
// ★ A copy do cancelamento escreve o EFEITO, não a pergunta. Quatro frases, nesta ordem:
// até quando o plano vale, até quando os créditos do ciclo valem, o que deixa de
// acontecer, e o que NÃO é afetado (o crédito comprado avulso). Uma confirmação que só
// pergunta "tem certeza?" transfere ao consultor a tarefa de adivinhar o que vai perder.
export const ASSINATURA = {
  // Protocolo do 502 das escritas (a Stripe falhou e a assinatura existe). Mesmo texto do
  // protocolo da compra avulsa, pela mesma fonte: os dois são o mesmo conceito na tela.
  PROTOCOLO: PACOTES.CHECKOUT_PROTOCOLO,
  // Rótulos de estado. O ramo da tela é decidido pelo `status_assinatura` (dado), nunca
  // pelo rótulo — rótulo é texto de exibição e mudaria a tela se alguém corrigisse um acento.
  STATUS_LABEL: {
    aguardando_pagamento: 'Confirmando pagamento',
    ativa: 'Ativa',
    inadimplente: 'Pagamento pendente',
    cancelamento_agendado: 'Cancelamento agendado',
  },
  AGUARDANDO_TEXTO:
    'Estamos confirmando seu pagamento. Assim que a Stripe confirmar, os créditos do primeiro ciclo entram na sua carteira.',
  // spec-007 (T016): o cartão confere sozinho enquanto espera, mas com TETO. Ao esgotar
  // as tentativas ele para e devolve o controle — girar para sempre consultaria a Stripe
  // a cada 3 s por uma tela que ninguém está olhando.
  TETO_ATINGIDO:
    'A confirmação está demorando mais que o normal e esta tela parou de conferir sozinha. Atualize para ver o estado mais recente.',
  ATUALIZAR: 'Atualizar',
  // spec-005 T040 (G-8): quem clicou em "Voltar" na Stripe NÃO pagou. Dizer "estamos
  // confirmando seu pagamento" a essa pessoa é afirmar uma cobrança que não existe — e
  // deixá-la esperando algo que nunca vai chegar. A copy diz o que houve e a saída.
  DESISTENCIA_LABEL: 'Pagamento não concluído',
  DESISTENCIA_TEXTO:
    'Você saiu do pagamento antes de concluir, e nada foi cobrado. Quando quiser, escolha um plano abaixo para assinar.',
  INADIMPLENTE_TEXTO: (data) =>
    `Não conseguimos cobrar seu cartão. Seus créditos atuais continuam valendo até ${data}.`,
  // Sem botão: o link de atualização do cartão é enviado pela Stripe por e-mail, e o
  // portal do cliente não faz parte do MVP. Um botão que não leva a lugar nenhum seria
  // pior que a instrução escrita.
  INADIMPLENTE_AJUDA:
    'Atualize a forma de pagamento pelo link que a Stripe enviou por e-mail ou fale com o suporte da AAWZ.',
  CANCELAR: 'Cancelar plano',
  REATIVAR: 'Reativar plano',
  // ── Cartão do plano ativo, protótipo v2 (duas faixas). Faixa 1: nome + chip do ciclo +
  // status, e UMA linha auxiliar: "R$ 4.500,00 por ano · renova em 12/09/2027" — ou, no
  // cancelamento agendado, "R$ 4.500,00 por ano · vale até 12/09/2027 e não renova" (no
  // lugar de uma faixa de aviso separada).
  CHIP_PERIODICIDADE: { mensal: 'Mensal', anual: 'Anual' },
  VALOR_POR_PERIODO: { mensal: (valor) => `${valor} por mês`, anual: (valor) => `${valor} por ano` },
  RENOVA_EM_CURTO: (data) => `renova em ${data}`,
  VALE_ATE_SEM_RENOVAR: (data) => `vale até ${data} e não renova`,
  ADICIONAR_CREDITOS: 'Adicionar créditos',
  // Faixa 2: os créditos do plano (número, "de {total}", a barra e a data) e os avulsos
  // (número). Só o essencial: sem "% restante", sem "na renovação", sem ajuda repetida —
  // o cartão ficava poluído (12/09/2026). Nada de "consumo previsto": o payload da
  // assinatura não traz média de consumo, e a tela não inventa número.
  PLANO_CREDITOS_TITULO: 'Créditos do plano',
  DE_TOTAL: (total) => `de ${total}`,
  EXPIRAM_EM: (data) => `Expiram em ${data}`,
  BARRA_ARIA: 'Créditos do plano restantes neste ciclo',
  AVULSOS_TITULO: 'Créditos avulsos',
  // ── A LINHA RECOLHÍVEL do modal (`creditos-assinatura-linha`, 18/09/2026). O cartão
  // inteiro pesava demais no topo da aba Planos; virou uma linha de resumo que abre.
  // Nada de informação sai: expandida, ela mostra o MESMO cartão de sempre.
  LINHA_PREFIXO: 'Meu plano',
  // "513,68 de 600,00 créditos" — os dois números já vêm formatados do view-model
  // (`ciclo.restantesLabel` e `ciclo.concedidosLabel`, este já com o "de ").
  LINHA_CREDITOS: (restantes, deConcedidos) => `${restantes} ${deConcedidos} créditos`,
  LINHA_ARIA_ABRIR: (plano) => `Mostrar os detalhes do plano ${plano}`,
  LINHA_ARIA_FECHAR: (plano) => `Ocultar os detalhes do plano ${plano}`,
  ERRO_LEITURA:
    'Não foi possível carregar sua assinatura agora. Tente novamente em alguns instantes.',
  ERRO_LEITURA_CTA: 'Tentar novamente',
  ARIA_CARTAO: (plano, status) => `Plano ${plano}, ${status}`,
  MODAL: {
    TITULO: (plano) => `Cancelar o plano ${plano}?`,
    // O efeito, escrito. Cada linha responde a uma pergunta que o consultor faria.
    EFEITO_PLANO: (data) =>
      `Você continua com o plano até ${data}, e os créditos deste ciclo valem até lá.`,
    EFEITO_RENOVACAO: 'Depois disso o plano não renova e nenhum crédito novo entra.',
    EFEITO_AVULSO: 'Os créditos que você comprou avulso não são afetados.',
    CANCELAR: 'Manter plano',
    CONFIRMAR: 'Cancelar plano',
  },
}

// ── O aceite dos termos na contratação (spec-009 US-1) ───────────────────────────────
// O consultor declara que leu os termos ANTES de sair para o pagamento. A caixa nasce
// DESMARCADA (AC-1.1) e é a mesma copy nas duas superfícies que assinam — a rota cheia
// `/central-ia/creditos` e o modal de créditos dentro do chat (AC-1.6).
//
// ★ A URL é a MESMA do aceite de serviço que já existe no repo
// (`src/modal/salvar-servico.vue`): um só documento público de Termos de Uso, para não
// nascerem duas verdades jurídicas. Verificado em 17/09/2026: responde 200 `application/pdf`.
export const TERMOS = {
  URL: 'https://aawz-public.s3.us-east-2.amazonaws.com/politicas/Termos%20de%20Uso.pdf',
  // O rótulo é quebrado em três porque o meio é um LINK dentro do texto clicável da caixa.
  ACEITE_PREFIXO: 'Li e concordo com os',
  ACEITE_LINK: 'Termos de Uso',
  ACEITE_SUFIXO: 'da AAWZ.',
  // O rótulo inteiro, para o leitor de tela (o link dentro do `<label>` fragmentaria a
  // leitura) e para o `aria-label` da caixa.
  ACEITE_ARIA: 'Li e concordo com os Termos de Uso da AAWZ.',
  LINK_ARIA: 'Abrir os Termos de Uso da AAWZ em nova aba (PDF)',
  // ★ AC-1.2 — "inerte E diz por quê". Dois canais, um por superfície: no modal o próprio
  // RÓTULO do botão diz o que falta (o padrão do módulo, como `ESCOLHA_UM_PLANO`); na
  // página, onde o botão vive em cada linha da tabela e não pode trocar de rótulo, o
  // motivo fica escrito ao lado da caixa.
  CTA_PENDENTE: 'Aceite os termos para continuar',
  MOTIVO_PENDENTE: 'Marque a caixa acima para liberar a assinatura dos planos.',
  // A recusa em si, quando a ação chegou sem passar pelo botão desabilitado (teclado,
  // automação). Sem "acima"/"ao lado": o snack aparece longe da caixa.
  RECUSA: 'Aceite os Termos de Uso antes de assinar um plano.',
}

// Subtítulo do CABEÇALHO DO MÓDULO, logo abaixo de "Central de IA", por rota
// (`routes.js` → `meta.subtitulo`; `views/nav-bar/ai-framework-nav-bar.vue` lê e passa
// ao `NavBarNavigation`). Substitui as intros "título + descrição" que cada view desenhava
// abaixo das abas: o nome da tela já é a aba, e a descrição vive num lugar só. As frases
// das telas que tinham intro foram reaproveitadas (Aprovações, Uso, Créditos).
export const SUBTITULO_ROTA = {
  CATALOGO: 'Ative agentes prontos para as rotinas do escritório.',
  AGENTE: 'O que o agente faz, como ele age e o que precisa para começar.',
  MEUS_AGENTES: 'Os agentes ativados no escritório: configure, pause ou converse.',
  CONVERSAR: 'Converse com os agentes ativados no seu escritório.',
  CREDITOS_PLANOS: CREDITOS.PAGINA_SUBTITULO,
  CREDITOS_ADICIONAR: PACOTES.SUBTITULO_PAGINA,
  CREDITOS_USO: 'Consumo de créditos por dia, movimentações e recibos do período.',
  CREDITOS_PAGAMENTO: 'Acompanhe o pagamento e a entrada dos créditos na sua carteira.',
  APROVACOES: APPROVALS.SUBTITLE,
  EXECUCOES: 'Cada execução de IA do escritório, com o custo em créditos.',
  USO: USAGE.SUBTITLE,
}
